import wooviUIEN from '@woovi/ui/locales/en.json';
import wooviUIES from '@woovi/ui/locales/es.json';
import wooviUIPTBR from '@woovi/ui/locales/pt-BR.json';

import wooviEN from './locales/en.json';
import wooviES from './locales/es.json';
import wooviPTBR from './locales/pt-BR.json';

export const en = {
  ...wooviUIEN,
  ...wooviEN,
};

export const es = {
  ...wooviUIES,
  ...wooviES,
};

export const ptBR = {
  ...wooviUIPTBR,
  ...wooviPTBR,
};
